import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceProductFacets(
    $categoryPath: [String!]!
    $filter: MarketplaceProductsFilter
  ) {
    category: marketplaceCategory(path: $categoryPath, filter: $filter) {
      path {
        code
        title
      }
      title
      children {
        path {
          code
          title
        }
        title
      }
      content {
        categoryPath
        pageTitle
        backendTitle
        metaDescription
        blurbTitle
        blurbBody
      }
      productTypes
    }
    productFacets: marketplaceProductFacets(
      categoryPath: $categoryPath
      filter: $filter
    ) {
      id
      type
      title
      options {
        id
        label
        group
      }
      searchFieldPlaceholder
    }
  }
`
